import React from "react";

export type IPantsIconProps = {};

const PantsIcon: React.FC<IPantsIconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={38.564}
      height={57.296}
      viewBox="0 0 38.564 57.296"
    >
      <g data-name="Group 5560">
        <path
          data-name="Path 354"
          d="M36.907 0H1.653A1.653 1.653 0 000 1.653v53.99A1.653 1.653 0 001.653 57.3h11.018a1.653 1.653 0 001.622-1.334L19.282 30.6l4.989 25.363a1.653 1.653 0 001.622 1.334h11.014a1.653 1.653 0 001.653-1.653V1.653A1.653 1.653 0 0036.907 0zm-33.6 10.467h3.3v4.074l-3.3 2.204zM35.259 53.99h-8.006l-6.346-32.272a1.653 1.653 0 00-3.243 0L11.307 53.99h-8V20.718L9.18 16.8a1.652 1.652 0 00.736-1.375v-4.958h18.731v4.958a1.652 1.652 0 00.736 1.375l5.875 3.917V53.99zm0-37.245l-3.305-2.2v-4.078h3.305zm0-9.583H3.307V3.305H35.26z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export { PantsIcon };
